/**
 * What a learner must be told about how a task was corrected (D-175), web and mobile: a recording
 * nobody could understand, the one redo offered for it, a trainer's mark and comment.
 */
export interface MarkNote {
  unintelligible: boolean;
  redoOffered: boolean;
  byTrainer: boolean;
  comment: string;
}

export function markNote(grade: unknown): MarkNote {
  const row = (typeof grade === "object" && grade !== null ? grade : {}) as Record<string, unknown>;
  const byTrainer = row.source === "trainer";
  const unintelligible = row.unintelligible === true && !byTrainer;
  return {
    unintelligible,
    redoOffered: unintelligible && row.redo_offered === true,
    byTrainer,
    comment: byTrainer && typeof row.comment === "string" ? row.comment : "",
  };
}

/** The microphone test before a redo passes once the learner's voice moved the level. */
export const MIC_CHECK_LEVEL = 0.06;

/** D-179: the words of a task's documents, material or cue card, whatever their shape. */
export function flattenText(value: unknown): string[] {
  if (typeof value === "string") return value.trim() ? [value.trim()] : [];
  if (Array.isArray(value)) return value.flatMap(flattenText);
  if (typeof value === "object" && value !== null) return Object.values(value).flatMap(flattenText);
  return [];
}

/** D-179: the voice of the examiner in a redo, on the phone. */
export function redoSpeechLanguage(exam: string): string {
  if (exam === "ielts_general") return "en-GB";
  return exam === "goethe" ? "de-DE" : "fr-FR";
}

/** Seconds as « m:ss » on the redo's clock. */
export function clockText(seconds: number): string {
  const whole = Math.max(Math.ceil(seconds), 0);
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, "0")}`;
}
